<table>
  <thead>
  <tr>
    <th>Vehicle Modal</th>
    <th>Visits</th>
    <th>Sold</th>
    <th>G</th>
    <th>F</th>
    <th>A</th>
  </tr>
  </thead>
  <tbody>
  <!-- Iterate over the carDataList array -->
  <tr *ngFor="let item of carDataList">
    <td>{{ item.modelUsed }}</td>
    <td>{{ item.visits }}</td>
    <td>{{ item.sold }}</td>
    <td>{{ item.g }}</td>
    <td>{{ item.f }}</td>
    <td>{{ item.a }}</td>
  </tr>
  </tbody>
  <!-- Optional Footer - if you wanted to calculate totals -->
  <!-- <tfoot>
    <tr>
      <td>Totals</td>
      <td>{{ calculateTotal('visits') }}</td>
      <td>{{ calculateTotal('sold') }}</td>
      <td>{{ calculateTotal('g') }}</td>
      <td>{{ calculateTotal('f') }}</td>
      <td>{{ calculateTotal('a') }}</td>
    </tr>
  </tfoot> -->
</table>
